import React, { useState } from "react";
import { Container } from "../layout/Container";
import styled from "styled-components";
import profileimg from "../img/tmp/profileImg.png";
import emptydrop from "../img/icons/emptymsg.svg";
import useTranslation from "../hooks/useTranslation";
// import TimeAgo from "javascript-time-ago";
// import en from "javascript-time-ago/locale/en";

const data = [
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: true,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: true,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
  {
    profileImg: profileimg,
    fullName: "Carla Saris",
    notRead: false,
    link: "/profile/:id",
    data: "Etiam id in dolor cras viverra diam, porta tigdgsfsdgsdbsdbsfb...",
    type: "follow",
  },
];
// TimeAgo.addDefaultLocale(en);

// const timeAgo = new TimeAgo("en-US");
export default function Notificationpage() {
  const { t } = useTranslation();
  const [notifs, setNotif] = useState(data);

  function handleClick(i) {
    let temp_state = notifs;
    temp_state[i].notRead = true;
    setNotif(temp_state);
    ///
  }
  function markAllRead() {
    let temp_state = notifs;

    for (let index = 0; index < temp_state.length; index++) {
      document.getElementById("row" + index).classList.remove("notread");
      temp_state.notRead = true;
    }
    console.log(temp_state);

    setNotif(temp_state);
    ///
  }

  return (
    <Container>
      <Cont>
        {notifs.length !== 0 ? (
          <Menu>
            <Header>
              <Title>{t('notifications.title')}</Title>
              <ReadMark onClick={markAllRead}>{t('notifications.mark_all_read')}</ReadMark>
            </Header>
            <Clm>
              {notifs.map(function (ob, i) {
                return (
                  <Row
                    key={i}
                    id={"row" + i}
                    onClick={() => {
                      handleClick(i);
                    }}
                    className={ob.notRead === false ? "notread" : ""}
                    href="#"
                  >
                    <Avatar>
                      <img src={ob.profileImg} alt={ob.fullName} />
                    </Avatar>
                    <Text>
                      <div style={{ display: "flex", width: "auto" }}>
                        <Name>
                          {ob.fullName + "  "} <Massege>{t('notifications.started_following')}</Massege>{" "}
                        </Name>
                      </div>

                      {/* <Time>{timeAgo.format(Date.now() - 60 * 1000)}</Time> */}
                    </Text>
                  </Row>
                );
              })}
            </Clm>
          </Menu>
        ) : (
          <Empty>
            <div>
              <img src={emptydrop} alt={t('notifications.empty_alt')} />
              <div>{t('notifications.no_notifications')}</div>
            </div>
          </Empty>
        )}
      </Cont>
    </Container>
  );
}

const Cont = styled.div`
  margin: 0 30%;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 576px) {
    margin: 0% 0% !important;
  }
  @media (max-width: 750px) {
    margin: 0% 0%;
  }
  @media (max-width: 1200px) {
    margin: 0% 15%;
  }
`;
const Menu = styled.div`
  cursor: initial;
  height: calc(100vh - 50px);
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;


  background-color: ${({ theme }) => theme.color.background};
  /* shadow-sm */
  /* box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.07); */
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.border};

  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  height: 80px;
  background: ${({ theme }) => theme.color.bg};
  /* border-bottom: 1px solid #f0f4f8; */
  margin-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  /* shadow-sm */
`;

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkerText};
  font-family: "Poppins Bold";
  font-size: 25px;
  line-height: 120%;
`;
const ReadMark = styled.button`
  color: ${({ theme }) => theme.color.primaryText};
  font-family: "Poppins Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  /* line-height: 150%; */
  padding: 5px 15px;
  background: transparent;
  outline: "none";
  border-radius: 8px;
  transition: all 300ms ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.color.border};
  }
`;

const Avatar = styled.a`
  cursor: pointer;
  background: ${({ theme }) => theme.color.bg};
  border-radius: 4px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const Text = styled.div`
  width: calc(100% - 37px);
  height: 30px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  justify-content: space-around;
`;
const Name = styled.div`
  color: ${({ theme }) => theme.color.darkerText};
  font-family: "Poppins Medium";
  font-size: 12px;
  width: 100%;
  margin-left: 3px;
`;
const Massege = styled.span`
  width: 100%;
  color: ${({ theme }) => theme.color.lighterText};
  font-family: "Poppins Regular";
  font-size: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
// const Time = styled.p`
//   text-transform: lowercase;
//   /* position: absolute;
//   right: 10px;
//   top: 7px; */
//   color: ${({ theme }) => theme.color.secondaryIcon};
//   font-family: "Poppins Regular";
//   font-size: 10px;
// `;

const Empty = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    & > img {
      width: 115px;
    }
    & > div {
      margin-top: 20px;
      color: ${({ theme }) => theme.color.lighterText};
      font-family: "Poppins Regular";
      font-weight: 500;
      font-size: 10px;
      line-height: 120%;
    }
  }
`;

const Row = styled.a`
  position: relative;
  width: 95%;
  height: 65px;
  min-height: 65px;
  background: ${({ theme }) => theme.color.bg};
  border-radius: 4px;
  display: flex;
  align-items: center;
  /* gap: 7px; */
  padding: 0px 10px;
  &:hover {
    background: ${({ theme }) => theme.color.secondaryBg};
  }
  &.notread {
    background: ${({ theme }) => theme.color.secondaryBg};
  }
`;

const Clm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  /* gap: 2px; */
  background: ${({ theme }) => theme.color.bg};
  overflow: auto;
`;
